<template>
  <v-card class="elevation-5 mb-4 px-5 py-3">
    <div v-if="periodosAno.length">
      <v-layout align-center justify-start row wrap>
        <h1
          class="font-weight-black mr-4 primary--text subheading"
          :class="{ 'text-xs-center': $vuetify.breakpoint.xs }"
        >
          Filtrar período
        </h1>
        <v-flex md2 sm3 xs12>
          <v-select
            height="20"
            label="Ano"
            no-data-text="Não há registros"
            v-model="ano"
            :items="periodosAno"
          ></v-select>
        </v-flex>
        <v-btn
          light
          class="mr-0"
          :color="highContrast ? 'white' : 'primary'"
          :disabled="!ano"
          @click="buscarDemonstrativo"
          >Filtrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          dark
          class="ma-3 white--text"
          color="primary"
          @click="baixarDemonstrativo"
        >
          Baixar
          <v-icon right>cloud_download</v-icon>
        </v-btn>
        <div v-if="this.beneficiarioPrincipalTodosContratos.length">
          <v-btn
            dark
            class="ma-3 white--text"
            color="primary"
            @click="baixarDemonstrativoTodosContratos"
          >
            Baixar todos os contratos
            <v-icon right>cloud_download</v-icon>
          </v-btn>
        </div>
      </v-layout>
    </div>
    <div v-else>Não há registros</div>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { buscaPeriodoAnoDemonstrativoIr } from "@/services/beneficiario";

const { mapState, mapMutations } = createNamespacedHelpers("portal");

const { mapGetters } = createNamespacedHelpers("beneficiario");

export default {
  name: "DemonstrativoIrVisualizar",
  props: {
    codigoBeneficiario: String
  },
  data() {
    return {
      ano: null,
      isLoading: false,
      loadingMessage: null,
      periodosAno: [],
      beneficiarioPrincipalTodosContratos: []
    };
  },
  computed: {
    ...mapGetters(["getFamiliaPessoa"]),
    ...mapState(["highContrast"])
  },
  watch: {
    codigoBeneficiario: {
      handler() {
        this.buscaPeriodoAno();
      }
    }
  },
  async created() {
    await this.buscaPeriodoAno();
    this.getFamiliaPessoa.forEach(pessoa => {
      if (pessoa.ativo === true && pessoa.titular === true) {
        this.beneficiarioPrincipalTodosContratos.push(pessoa.id);
      }
    });
  },
  methods: {
    ...mapMutations(["setErrorToast"]),
    baixarDemonstrativo() {
      this.$emit("baixar-demonstrativo");
    },
    baixarDemonstrativoTodosContratos() {
      this.$emit(
        "baixar-todos-demonstrativos",
        this.beneficiarioPrincipalTodosContratos,
        this.ano
      );
    },
    buscarDemonstrativo() {
      this.$emit("buscar-demonstrativo", this.ano);
    },
    buscaPeriodoAno() {
      this.$emit("show-loading", true);

      buscaPeriodoAnoDemonstrativoIr(this.codigoBeneficiario)
        .then(response => {
          const errorMessage = response.data?.message;

          if (errorMessage) {
            this.setErrorToast(errorMessage);
          } else {
            this.periodosAno = response;
          }
        })
        .finally(() => {
          this.$emit("show-loading", false);

          if (this.periodosAno.length) {
            this.ano = this.periodosAno[0];
            this.buscarDemonstrativo();
          }
        });
    }
  }
};
</script>
